import React from 'react';
import { getWidth, getWidthPosition } from '../helpers/getWidth';
import moment from 'moment/moment';

export const usePlanFact = (item, type, activeTab) => {
    let planWidth = getWidth(Number(item.planned?.days_count), activeTab);
    let factWidth = getWidth(Number(item.actual?.days_count), activeTab);

    if (type === 'position') {
        planWidth = getWidthPosition(Number(item.planned?.days_count), activeTab);
        factWidth = getWidthPosition(Number(item.actual?.days_count), activeTab);
    }

    const startDateFact = item.actual?.start_date ? item.actual?.start_date : '';
    const startDatePlan = item.planned.start_date ? item.planned.start_date : '';

    const formattedStartFact = moment(startDateFact).hour(0).minute(0).seconds(0).format();
    const formattedStartPlan = moment(startDatePlan).hour(0).minute(0).seconds(0).format();

    const dateDiff = moment(formattedStartFact).diff(formattedStartPlan, 'days');

    let factLeft = dateDiff * 24;
    if (activeTab === 'week') {
        factLeft = dateDiff * 11;
    }

    if (activeTab === 'month') {
        factLeft = dateDiff * 7;
    }

    return { planWidth, factWidth, factLeft };
};
